import { useContext } from "react";

import { BalancesContext } from "../contexts";

export function useBalances() {
  const balancesContext = useContext(BalancesContext);

  if (!balancesContext)
    throw new Error(
      "The balances context can only be used inside the Balances Provider"
    );

  return {
    // active
    activeBalanceCurrency: balancesContext.activeBalanceCurrency,
    setActiveBalanceCurrency: balancesContext.setActiveBalanceCurrency,

    // remote
    isLoadingBalances: balancesContext.isLoading,
    balances: balancesContext.data,
    refreshBalances: balancesContext.refreshRemoteData,
  };
}
